export const AG_GRID_LOCALE_EN = {};
